import { render } from "./ProductCharacteristicsRoster9Screen.vue?vue&type=template&id=f6f714a6&scoped=true"
const script = {}

import "./ProductCharacteristicsRoster9Screen.vue?vue&type=style&index=0&id=f6f714a6&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f6f714a6"]])

export default __exports__